<template>
  <li>
    <div
      :class="[
        selectedPath === bubbleIndex + '' ? 'focused' : '',
        errorPath.includes(bubbleIndex + '') ? 'has-error' : '',
      ]"
      @click="selectNode(message, bubbleIndex + '')"
    >
      <span class="node-icon">
        <q-icon
          size="xs"
          :name="showBubble ? 'arrow_drop_down' : 'arrow_right'"
          @click="showBubble = !showBubble"
        />
      </span>
      <span>bubble</span>
    </div>
    <ul :style="!showBubble ? 'display: none;' : ''">
      <li>
        <div
          :class="[
            selectedPath === bubbleIndex + '.header' ? 'focused' : '',
            errorPath.includes(bubbleIndex + '.header') ? 'has-error' : '',
          ]"
          @click="selectNode(message.header, bubbleIndex + '.header')"
        >
          <span class="node-icon">
            <q-icon
              size="xs"
              :name="showHeader ? 'arrow_drop_down' : 'arrow_right'"
              @click="showHeader = !showHeader"
            />
          </span>
          <span>header</span>
        </div>
        <ul :style="!showHeader ? 'display: none;' : ''">
          <FlexMessageTreeNodes
            :component="message.header"
            :type="message.header.type"
            :parentPath="bubbleIndex + '.header.'"
            :selectedNode="selectedNode"
            :selectedPath="selectedPath"
            :errorPath="errorPath"
            @onSelectNode="selectNode"
            @onHoverNode="(val) => $emit('onHoverNode', val)"
            v-if="message.header"
          />
        </ul>
      </li>
      <li>
        <div
          :class="[
            selectedPath === bubbleIndex + '.hero' ? 'focused' : '',
            errorPath.includes(bubbleIndex + '.hero') ? 'has-error' : '',
          ]"
          @click="selectNode(message.hero, bubbleIndex + '.hero')"
        >
          <span class="node-icon">
            <q-icon
              size="xs"
              :name="showHero ? 'arrow_drop_down' : 'arrow_right'"
              @click="showHero = !showHero"
            />
          </span>
          <span>hero</span>
        </div>
        <ul :style="!showHero ? 'display: none;' : ''">
          <FlexMessageTreeNodes
            :component="message.hero"
            :type="message.hero.type"
            :parentPath="bubbleIndex + '.hero.'"
            :selectedNode="selectedNode"
            :selectedPath="selectedPath"
            :errorPath="errorPath"
            @onSelectNode="selectNode"
            @onHoverNode="(val) => $emit('onHoverNode', val)"
            v-if="message.hero"
          />
        </ul>
      </li>
      <li>
        <div
          :class="[
            selectedPath === bubbleIndex + '.body' ? 'focused' : '',
            errorPath.includes(bubbleIndex + '.body') ? 'has-error' : '',
          ]"
          @click="selectNode(message.body, bubbleIndex + '.body')"
        >
            <span class="node-icon">
              <q-icon
                size="xs"
                :name="showBody ? 'arrow_drop_down' : 'arrow_right'"
                @click="showBody = !showBody"
              />
            </span>
          <span>body</span>
        </div>
        <ul :style="!showBody ? 'display: none;' : ''">
          <FlexMessageTreeNodes
            :component="message.body"
            :type="message.body.type"
            :parentPath="bubbleIndex + '.body.'"
            :selectedNode="selectedNode"
            :selectedPath="selectedPath"
            :errorPath="errorPath"
            @onSelectNode="selectNode"
            @onHoverNode="(val) => $emit('onHoverNode', val)"
            v-if="message.body"
          />
        </ul>
      </li>
      <li>
        <div
          :class="[
            selectedPath === bubbleIndex + '.footer' ? 'focused' : '',
            errorPath.includes(bubbleIndex + '.footer') ? 'has-error' : '',
          ]"
          @click="selectNode(message.footer, bubbleIndex + '.footer')"
        >
          <span class="node-icon">
            <q-icon
              size="xs"
              :name="showFooter ? 'arrow_drop_down' : 'arrow_right'"
              @click="showFooter = !showFooter"
            />
          </span>
          <span>footer</span>
        </div>
        <ul :style="!showFooter ? 'display: none;' : ''">
          <FlexMessageTreeNodes
            :component="message.footer"
            :type="message.footer.type"
            :parentPath="bubbleIndex + '.footer.'"
            :selectedNode="selectedNode"
            :selectedPath="selectedPath"
            :errorPath="errorPath"
            @onSelectNode="selectNode"
            @onHoverNode="(val) => $emit('onHoverNode', val)"
            v-if="message.footer"
          />
        </ul>
      </li>
    </ul>
  </li>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageComponents from '@/components/common/flex-message/FlexMessageComponents.vue'
import FlexMessageTreeNodes from '@/components/common/flex-message/FlexMessageTreeNodes.vue'

@Options({
  components: { FlexMessageTreeNodes, FlexMessageComponents },
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class FlexMessageBubbleTree extends Vue {
  @Prop()
  message!: IFlexMessageBubble

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  bubbleIndex!: number

  @Prop()
  errorPath!: string[]

  showBubble = true
  showHeader = true
  showHero = true
  showBody = true
  showFooter = true

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
